import styled from "styled-components";

export const EmailNotificationCard = styled.div`
    border:1px solid #c9cdd2;
    border-radius:8px;
    padding: 1.5em ;
`